import React, { useState, useRef, useEffect } from "react";
import { sendRequest } from '../../hooks/requests/useRequest';
import debounce from "lodash.debounce";

export const useGlobalSearch = () => {

  const [value, setValue] = useState("");
  const [resultsSearch, setResultsSearch] = useState([]);

  const debouncedSearch = useRef(
    debounce(async (query, matchExact) => {

      if (!query || query.length < 3) {
        setResultsSearch([
          {
            isMessage: true,
            message: "Escribe al menos 3 caracteres para buscar"
          }
        ]);
        return;
      }

      try {
        let requestOptions = {
          method: 'GET'
        };

        const response = await sendRequest(
          requestOptions,
          `WorkOrder/SearchGlobalWorkOrder?text=${query}&match_exact=${matchExact}`
        );

        const grouped = response?.data ?? [];

        let flat = [];

        grouped.forEach(group => {
          flat.push({
            isGroup: true,
            group_name: group.group_name,
            group_id: group.group_id,
            items: group.items
          });

          group.items.forEach(item => {
            flat.push({
              ...item,
              isGroup: false,
            });
          });
        });

        if (flat.length === 0) {
          setResultsSearch([
            {
              isMessage: true,
              message: "Sin coincidencias encontradas"
            }
          ]);
          return;
        }

        setResultsSearch(flat);

      } catch (error) {
        setResultsSearch([]);
      }

    }, 400)
  ).current;

  const searchGlobal = (e, matchExact = false) => {
    const query = e?.query ?? value;

    debouncedSearch(query, matchExact);
  };

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  return {
    value,
    setValue,
    resultsSearch,
    searchGlobal,
  };
};
